export default "__VITE_ASSET__laSU34oM__"